module.exports = __webpack_public_path__ + "media/images/cart/route02-4798f0c106baca547ca3cfb1402b546c.gif";